import { createSelector } from 'reselect';
import PartnerInfoConstants from 'Shared/constants/PartnerInfo.constants';

const getSlice = state => state.PartnerInfo;

export const getPartnerInfo = createSelector([getSlice], slice =>
  slice.get(PartnerInfoConstants.State.PARTNER_INFO)?.toJS()
);
